import Immutable from 'immutable';

const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function getRandomString(length: number, prefix = 'd'): string {
  return [...Array(length)].reduce((acc: string): string => {
    return (
      acc + characters.charAt(Math.floor(Math.random() * characters.length))
    );
  }, prefix);
}

export async function downloadFileWithAnchor(
  url: string,
  filename: string
): Promise<void> {
  const resp = await fetch(url);
  const blob = await resp.blob();

  const blobUrl = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = blobUrl;
  a.setAttribute('download', filename);

  const rootEl = document.getElementById('root');

  if (rootEl) {
    rootEl.appendChild(a);

    a.click();

    rootEl.removeChild(a);
  }
}

export async function getDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      if (e.target && typeof e.target.result === 'string') {
        resolve(e.target.result);
      } else {
        reject(new Error('getDataURL: e.target.result is not a string'));
      }
    };

    reader.readAsDataURL(file);
  });
}

export function getDateString(): string {
  const date = new Date();
  const dateString = `${
    date.getMonth() + 1
  }.${date.getDate()}.${date.getFullYear()}`;
  return dateString;
}

export function truncateString(
  str: string,
  maxLength: number,
  withEllipsis = true
): string {
  return str.length > maxLength
    ? `${str.substring(0, maxLength)}${withEllipsis ? '...' : ''}`
    : str;
}

interface WithName {
  name: string;
}

export function extractPDFs<T extends WithName>(
  files: Immutable.List<T>
): Immutable.List<T> {
  const filtered = files.filter((doc) => doc.name.endsWith('.pdf'));
  return filtered;
}
